import type { MessageDescriptorV2 as MessageDescriptor } from '@atlassian/jira-intl/src/v2/types.tsx';
import {
	ALERTS_FEATURE,
	ONCALL_FEATURE,
	SERVICES_FEATURE,
} from '@atlassian/jira-servicedesk-common/src/service-project-features/constants.tsx';
import messages from './messages';

export const FEATURE_TITLE_LOOKUP: { [key: string]: MessageDescriptor } = {
	[ALERTS_FEATURE]: messages.alertsTitle,
	[ONCALL_FEATURE]: messages.oncallTitle,
	[SERVICES_FEATURE]: messages.servicesTitle,
} as const;
